import React from "react";
import Label from "components/general/Label"
import Competitor from 'components/presentation/Competitor';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Noc from "components/presentation/Noc";

const Jury = ({ officials }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()

    return (
        <>
        <table className="table">
            <thead>
                <tr>
                    <th className="text-start"><Label data="HeaderJury" sport={mirs_discipline} /></th>
                </tr>
            </thead>
            <tbody>
            {officials.map((i, index) => {
                if(i?.function?.description !== 'Judge')
                {
                    return (
                        <tr key={index} >
                            <td className="d-flex fw-bold">
                                    {i?.function?.description}&emsp;<Noc {...i?.official?.organisation}/>&emsp;<Competitor hidePicture={true} hideNoc={true} {...i?.official} />
                            </td>
                        </tr>
                    )
                }
            })}
            </tbody>
        </table>
        </>
    )
}

export default Jury;